import { render, staticRenderFns } from "./datatable-collection.vue?vue&type=template&id=6702d08d&"
import script from "./datatable-collection.vue?vue&type=script&lang=js&"
export * from "./datatable-collection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports